import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-lg w-full text-center" }
const _hoisted_2 = { class: "mb-8 flex justify-center" }
const _hoisted_3 = { class: "bg-primary5 p-8 rounded-full ring-8 ring-primary5/50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-6xl md:text-7xl font-extrabold text-primary mb-2",
  "aria-hidden": "true"
}, "404", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl md:text-3xl font-bold text-textPrimary mb-4" }, "Página não encontrada", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-lg mb-10 leading-relaxed" }, " A página que você está tentando acessar não existe, foi movida ou o endereço está incorreto. ", -1)
const _hoisted_7 = { class: "flex flex-col sm:flex-row gap-4 justify-center items-center" }

import { onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { mdiCompassOffOutline } from '@mdi/js'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PATHS from '@/router/paths'
import { isCompanyAuthenticated } from '@/utils/storage'
import isSSR from '@/_base/isSSR'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter()

const isLoggedIn = isCompanyAuthenticated()
// vue-router 4 grava o entry anterior em history.state.back — null em deep-link direto
const canGoBack = !isSSR && Boolean(window.history.state?.back)

const goHome = () => router.push(isLoggedIn ? PATHS.DASHBOARD : PATHS.SIGNIN)

let previousTitle = ''
onMounted(() => {
  previousTitle = document.title
  document.title = 'Página não encontrada'
})
onBeforeUnmount(() => {
  document.title = previousTitle
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testid": "not-found-page",
    class: _normalizeClass(["w-full flex items-center justify-center px-4", _unref(isLoggedIn) ? 'min-h-[60vh] py-16' : 'min-h-screen bg-gray-50/50'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_icon, {
            icon: _unref(mdiCompassOffOutline),
            size: "100",
            class: "text-primary"
          }, null, 8, ["icon"])
        ])
      ]),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FilledButton, {
          text: "Ir para o início",
          width: "220px",
          height: "48px",
          "data-testid": "not-found-home-button",
          onClick: goHome
        }),
        (_unref(canGoBack))
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Voltar",
              width: "220px",
              height: "48px",
              "data-testid": "not-found-back-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})